import { Axios } from 'utils/AxiosConfig'

export const getAdvisorWantedCompany = async (payload) => {
  const { data: response } = await Axios.get(`member/profile/advisor/wanted-company`, payload)
  return response
}
export const getProfileWantedCompany = async (payload) => {
  const { data: response } = await Axios.get(`member/profile/wanted-company`, payload)
  return response
}
export const putPostedStatusWantedCompany = async (payload) => {
  const { data: response } = await Axios.put(
    `/member/profile/wanted-company/is-posted-flag/${payload.id}`,
    payload.params
  )
  return response
}
export const deleteWantedCompany = async (id) => {
  const { data: response } = await Axios.delete(`/member/profile/advisor/wanted-company/${id}`)
  return response
}
export const deleteWantedCompanyByBuyer = async (id) => {
  const { data: response } = await Axios.delete(`member/package-subscription/buyer/${id}`)
  return response
}
